import clsx from 'clsx/lite';
import { delay, Glow, iconClassName, styles, svgProps } from '@/components/service-showcase/icons/shared';
import type { IServiceShowcaseSvgIconProps } from '@/components/service-showcase/icons/type';

const MESH_PRIMARY = [
  [190, 110, 142, 70],
  [190, 110, 244, 68],
  [190, 110, 250, 140],
  [190, 110, 146, 156],
  [142, 70, 244, 68],
  [244, 68, 250, 140],
  [250, 140, 146, 156],
  [146, 156, 142, 70],
  [142, 70, 92, 48],
  [244, 68, 300, 52],
  [250, 140, 306, 166],
  [146, 156, 98, 180],
  [142, 70, 84, 104],
  [244, 68, 296, 104],
];

const MESH_SECONDARY = [
  [92, 48, 84, 104],
  [84, 104, 98, 180],
  [92, 48, 146, 156],
  [84, 104, 146, 156],
  [98, 180, 146, 156],
  [250, 140, 296, 104],
  [296, 104, 306, 166],
  [250, 140, 306, 166],
];

const MESH_NODES = [
  [190, 110, 5.5, 1],
  [142, 70, 4, 0.85],
  [244, 68, 4, 0.85],
  [250, 140, 4, 0.85],
  [146, 156, 4, 0.85],
  [92, 48, 2.8, 0.55],
  [300, 52, 2.8, 0.55],
  [306, 166, 2.8, 0.55],
  [98, 180, 2.8, 0.55],
  [84, 104, 2.8, 0.5],
  [296, 104, 2.8, 0.5],
];

export default function SignalMeshIcon(props: IServiceShowcaseSvgIconProps) {
  const { active = true, className, ...rest } = props;

  return (
    <svg {...svgProps} {...rest} className={iconClassName(active, clsx(styles.mesh, className))}>
      <Glow cx={190} cy={110} r={86} opacity={0.2} />

      {MESH_PRIMARY.map((line, i) => (
        <line
          key={`primary-${i.toString()}`}
          x1={line[0]}
          y1={line[1]}
          x2={line[2]}
          y2={line[3]}
          stroke='currentColor'
          strokeWidth='1'
          strokeOpacity='0.38'
          className={styles.link}
          style={delay(`${0.1 + i * 0.04}s`)}
          pathLength='1'
        />
      ))}
      {MESH_SECONDARY.map((line, i) => (
        <line
          key={`secondary-${i.toString()}`}
          x1={line[0]}
          y1={line[1]}
          x2={line[2]}
          y2={line[3]}
          stroke='currentColor'
          strokeWidth='0.9'
          strokeOpacity='0.3'
          className={styles.link}
          style={delay(`${0.7 + i * 0.05}s`)}
          pathLength='1'
        />
      ))}
      {MESH_NODES.map((node, i) => (
        <circle
          key={`node-${i.toString()}`}
          cx={node[0]}
          cy={node[1]}
          r={node[2]}
          fill='currentColor'
          fillOpacity={node[3]}
          className={styles.pop}
          style={delay(`${0.3 + i * 0.05}s`)}
        />
      ))}
    </svg>
  );
}
